'use strict';

/* Main Controller */
import BannerPin from '../../ads/BannerAdsPin';
import SocialBarLoader from "../../SocialBar/SocialBarLoader";

angular.module('storyApp').controller('StoryCtrl',
    ['$scope', '$rootScope', '$location', '$sce', 'threeThingsAPI', 'trackingUtils', 'cqArticleService', 'storyScroll', 'storyInView', 'storyEvents','threeThingEvents','metaDataFactory', 'parselyService',
        function($scope, $rootScope, $location, $sce, threeThingsAPI, trackingUtils, cqArticleService, storyScroll, storyInView, storyEvents, threeThingEvents, metaDataFactory, parselyService) {

            var loc = location;

            //original story setup
            var originalPath = loc.pathname + loc.search.substring();

            //load meta data for original story
            var originalMetadata = metaDataFactory.getMainStoryMetaData();

            /**
             * onPageChanged needs to run for right rail pinning and the original metadata
             * @param Number storyIndex - 1: the orignal story
             * @param Object metaData - originalMetadata for main story's meta tags, ads and analytics
             * @param Boolean onPageload - true to indicate if onPageChanged is called on pageload
             **/
            storyEvents.onPageChanged(1, originalMetadata, true);



            $location.state({ storyIndex: 0 });

            $scope.threeThings = [];

            $scope.relatedContent = [];

            $scope.storyViewIndex = 0;

            //setup render article
            cqArticleService.onRenderArticle = function(relatedIndex,articleContent){

                $scope.relatedContent[relatedIndex] = $sce.trustAsHtml(articleContent);

            };

            //setup 3 things from ng-init
            $scope.getThreeThings = function(apiUrl) {

                try {

                    //calling threeThingsAPI.getThreeThings when 3things apiUrl is returned from backend
                    if (apiUrl) {
                        threeThingsAPI.getThreeThings(apiUrl).then(function(data) {

                            //show 3 things on the left
                            $scope.threeThings = data;

                            for (var i = 0, len = data.length; i < len; i++) {
                                //add data returned from 3 things to articles array
                                //data[i].url will be used as browser url
                                //data[i].articleUrl will be used when fetching the article content
                                cqArticleService.addArticle(data[i].url, data[i].articleUrl);
                            }

                            //fetch and render the first story on the three things on page load
                            cqArticleService.fetchArticle(0).then(function(){
                                cqArticleService.renderArticle(0);
                            });

                        });

                    }
                    
                } catch(e) {

                    console.log("something went wrong -",e);
                }

            };

            $scope.onclick = function($event, relatedIndex) {

                // Creating and triggering the Click event to Relevancy Engine

                trackingUtils.sendThreeThingsClickedData($scope.threeThings, relatedIndex);

                //related index will be 0-3 for four stories
                var elId = 'story-' + (relatedIndex + 2),
                    thisClickedStoryFetched =  cqArticleService.articles[relatedIndex].isFetched;

                // if thisClickedStoryFetched is false, that means users click on either third or last story on the 3things
                if(!thisClickedStoryFetched) {

                    //Load Social Bars for the new rendered story
                    SocialBarLoader();

                    /*
                     * if relatedIndex is equal to 2, that means users click on last story on the 3things.
                     * We will fetch and render third story first, and then fetch and render the last story.
                     */
                    if(relatedIndex === 2 ) {
                        cqArticleService.fetchArticle(1).then(function(){
                            cqArticleService.renderArticle(1);

                            cqArticleService.fetchArticle(2).then(function(){

                                cqArticleService.renderArticle(2);

                                /*
                                 * after render last story, check if third story is rendered completely.
                                 * if third story is rendered completely, scroll to last story
                                 */
                                storyEvents.monitorElmOnLoad( document.getElementById('story-3'), function() {

                                    storyScroll.jumpToElement(elId, 300, true)
                                });

                            });

                        });

                    } else {

                        /*
                         * if relatedIndex is not equal to 2, that means users click on the third story on the 3things.
                         * We will fetch and render third story first
                         */
                        cqArticleService.fetchArticle(1).then(function(){

                            cqArticleService.renderArticle(1);

                            /*
                             * check if third story is rendered completely.
                             * if third story is rendered completely, scroll to third story
                             */
                            storyEvents.monitorElmOnLoad( document.getElementById('story-3'), function() {

                                storyScroll.jumpToElement(elId, 100, true)
                            });
                        });

                    }

                } else {

                    //otherwise, scrollTo that element immediately since the story has been rendered
                    storyScroll.jumpToElement(elId, 0, true);
                }

                //uncomment the following line until we start adding skinad on story page template
                //skinAdsFactory.toggleSkinAdPosOnClick();

                /*
                 * broadcast BannerPin object that user clicks on the 3 things
                 * don't activate ad pin when user clicks on the 3 things on the left rail
                 * otherwise; the pinned ad will cover the top of the story on the 3 things
                 * */
                BannerPin.isClickedOn3things = true;

                $event.preventDefault();
            };

            //storyInView.onChange is triggered on storyInView.goto method when the storyViewIndex is changed
            storyInView.onChange = function(storyViewIndex) {

                var newUrl;

                $scope.storyViewIndex = storyViewIndex;

                //apply updates if it is not the original story
                if(storyViewIndex > 0) {

                    newUrl = cqArticleService.getUrl(storyViewIndex -1);
                    parselyService.passingUrl(newUrl);

                    $location.url(newUrl).state({storyIndex: storyViewIndex});
                    //need to call for pushstate to start immediately
                    $scope.$apply();

                    //Load Social Bars for the new rendered story
                    SocialBarLoader();

                    /*
                     * The first story on the three things is rendered on page load.
                     * When the storyViewIndex is changed to 1 meaning users scroll
                     * from  original story to the first story on the 3 things,
                     * we fetch and render the second story on the 3 things.
                     * When the storyViewIndex is changed to 2 meaning users scroll
                     * to the second story on the 3 things (third story on the page),
                     * we fetch and render the third story (last story) on the 3 things.
                     */

                    if(storyViewIndex < 3){

                        if(!cqArticleService.articles[storyViewIndex].isFetched && !cqArticleService.articles[storyViewIndex].isFetching) {
                            cqArticleService.fetchArticle(storyViewIndex).then(function () {
                                cqArticleService.renderArticle(storyViewIndex);
                            });
                        }
                    }

                    storyEvents.onPageChanged(storyViewIndex + 1, cqArticleService.getMetadata(storyViewIndex -1), false);

                } else {
                    //apply updates if it is the original story
                    newUrl = originalPath;
                    $location.url(newUrl).state({storyIndex: storyViewIndex});
                    $scope.$apply()

                    storyEvents.onPageChanged(storyViewIndex + 1, originalMetadata, false);
                }

                //somehow this has to be called because the angular digest is not fully done.
                $rootScope.$apply();

                return newUrl;

            };

        }]);



// WEBPACK FOOTER //
// ./assets/components/threethings/controllers/storyCtrl.js